<template>
  <gj-modal
      :visible.sync="modalVisible"
      :destroyOnClose="true"
      notFooterPadding
      size="1200_auto"
      @open="modalOpen"
      >
    <template #header>
      <div class="header">
        <span>销售表现趋势分析</span>
        <span v-if="params.groupType =='marketId'" class="gj-content" style="margin-left: 10px;font-size: 12px;">店铺：{{params.row.marketName}}</span>

       </div>
    </template>
    <template #content>
      <div class="analysis-content">
        <div>
          <el-row type="flex" style="padding: 0 10px;" v-if="params.groupType !='marketId'">
            <gj-image
                
                :src="params.row.imageUrl"
                :size="65"></gj-image>
            <div style="flex: 1; margin-left: 20px; margin-right: 20px;">
              <div class="gj-mb10" style="width:1004px">

              <div class="product-name text-ellipsis-1" style="width:900px">
                {{params.row.crawlTitle}}
              </div>
              </div>
              <el-row class="gj-mb10">
                <el-col :span="6" v-if="params.row.asin ">
                  <div class="text-ellipsis-1">
                    <span class="gj-label">ASIN：</span>
                    <gj-tooltip content="">
                      <span class="gj-content">{{params.row.asin}}</span>
                    </gj-tooltip>
                  </div>
                </el-col>
                <el-col :span="6" v-if="params.row.variationAsin">
                  <div class="text-ellipsis-1">
                    <span class="gj-label">父ASIN：</span>
                    <gj-tooltip >
                      <span class="gj-content">{{params.row.variationAsin}}</span>
                    </gj-tooltip>
                  </div>
                </el-col>
                <el-col :span="6" v-if="params.row.msku">
                  <div class="text-ellipsis-1">
                    <span class="gj-label">MSKU：</span>
                    <gj-tooltip content="">
                      <span class="gj-content">{{params.row.msku}}</span>
                    </gj-tooltip>
                  </div>
                </el-col>
                <el-col :span="6" v-if="params.row.marketName">
                  <div class="text-ellipsis-1">
                    <span class="gj-label">店铺/国家：</span>
                    <gj-tooltip content="">
                      <span class="gj-content">{{params.row.marketName}}</span>
                    </gj-tooltip>
                  </div>
                </el-col>
              </el-row>

            </div>
          </el-row>
          <app-filter-group
              style="margin-top: 16px"
              :reset="false"
              @query="$gjQuery()">
            <gj-date-picker
                v-model="filter.date"

                type="daterange"

            ></gj-date-picker>
            <gj-radio-group
                v-model="filter.dateType"

                :options="[
                  {id: 'day', text: '日'},
                  {id: 'week', text: '周'},
                  {id: 'month', text: '月'},
                ]">
            </gj-radio-group>
            <template #right>
               <gj-radio-group
                  v-model="viewType"
                  @change="changViewType2($event)"
                  :options="[
                    {id: 'chart', text: '图表'},
                    {id: 'list', text: '列表'},
                  ]">
              </gj-radio-group>
              <gj-tool-group
                  :modal-mount-to="$mountTo"
                  :table-name="tableName" :table-columns="columns"
                  :download="true"
                  download-url="/operation/listingAnalyze/export/trendAnalyze"
                  :download-params="globalParams"
              ></gj-tool-group>
             
              
            </template>
          </app-filter-group>
          <app-filter-group
              v-show="viewType === 'chart'"
              style="margin-top: 16px"
              :reset="false"
              :query="false">
              <gj-select
                ref="leftSelect"
                name="left"
                v-model="leftSelected"
                :options="leftSelectOption"
                :multiple="true"
                placeholder="请选择"
                type="multi-check"
                width="140px"
                @change="leftSelectChange"
              ></gj-select>
            <template #right>
              <gj-select
                ref="rightSelect"
                name="right"
                v-model="rightSelected"
                :options="rightSelectOption"
                :multiple="true"
                placeholder="请选择"
                clearable
                width="140px"
                type="multi-check"
                @change="rightSelectChange"
              ></gj-select>
            </template>
          </app-filter-group>

          <div                 ref="rightTable"
 v-show="viewType === 'list'" style="margin-top:16px;margin-bottom:16px">

            <gj-table
                v-if="alreadyShowTable"
                :name="tableName"
                :data="currentTableData"
                :pagination="pagination"
                :page-sizes = "[20, 50, 100]"
                :page-size="pageSize"
                :index="false"
                @page-change="getStaticData"
                :columns="columns"
                :loading="loading"
                :adapt-height="false"
                :height="540"
                
                >
                <template v-slot:returnsRate="{row}">
                  {{row.returnsRate? row.returnsRate  + "%" :'-'}}
                </template>
                <template v-slot:cr="{row}">
                  {{row.cr? row.cr  + "%" :'-'}}
                </template>
            
                <template v-slot:BuyBox="{row}">
                  {{row.BuyBox? row.BuyBox  + "%" :'-'}}
                </template>
                <template v-slot:ctr="{row}">
                  {{row.ctr? row.ctr  + "%" :'-'}}
                </template>
                <template v-slot:unitSessionPercentage="{row}">
                  {{row.unitSessionPercentage? row.unitSessionPercentage  + "%" :'-'}}
                </template>
                <template v-slot:acoS="{row}">
                  {{row.acoS? row.acoS  + "%" :'-'}}
                </template>
                <template v-slot:acoAS="{row}">
                  {{row.acoAS? row.acoAS  + "%" :'-'}}
                </template>
                <template v-slot:asoAS="{row}">
                  {{row.asoAS? row.asoAS  + "%" :'-'}}
                </template>
                <template v-slot:grossProfitRate="{row}">
                  {{row.grossProfitRate? row.grossProfitRate  + "%" :'-'}}
                </template>
                <template v-slot:salesNetProfitRate="{row}">
                  {{row.salesNetProfitRate? row.salesNetProfitRate  + "%" :'-'}}
                </template>
                <template v-slot:adsOrdersRate="{row}">
                  {{row.adsOrdersRate? row.adsOrdersRate  + "%" :'-'}}
                </template>
            </gj-table>
            
          </div>
          <div v-show="viewType === 'chart'" class="content-options">
            <div id="enlargeChart" ref="enlargeChart" class="chart-container"
              :style="{width: '100%',height: '400px'}">
            </div>
            <gj-table
                :data="chartTableData"
                :columns="chartTableColumns"
                :default-sort = "{prop: 'date', order: 'descending'}"
                :adapt-height="false"
                :height="152"
                :index="false"
                :loading="loading"
                >
                <template v-slot:header:totalTime>
                    {{time}}
                  </template>
            </gj-table>
          </div>
        </div>

      </div>
    </template>
    <template #footer>
    </template>
  </gj-modal>
</template>

<script>
  import {modalMixIn} from "../../../../../minxins";
  import {getListingTrendAnalyze,getListingTrendTotal} from "@/api/statistics";
  import { convertToDate } from "@/utils/date.util";

  export default {
    name: "operation-analysis-modal-new",
    mixins: [modalMixIn],
    props: {
      params:null,
    },
    data() {
      return {
        loading:false,
        tableName: 'operation-analysis-trend-table',
        tableData: [],
        currentTableData:[],
        pagination:{
          currentPage: 1,
          pageSize: 20,
          total: 0,
        },
        globalParams:{},
        pageSize:20,
        columns: [
          {id: 'dateRange', header: '日期', field: 'dateRange', width: '140px', sortable: false, notCustomColumn: true},
          {id: 'unitsOrdered', header: '销量', field: 'unitsOrdered', width: '140px', sortable: false, notCustomColumn: true},
          {id: 'unitsOrderedB2b', header: '销量-B2B', field: 'unitsOrderedB2b', width: '140px', sortable: false, default: true},
          {id: 'multiChannelOrders', header: '多渠道销量', field: 'multiChannelOrders', width: '140px', sortable: false, default: true},
          {id: 'orders', header: '订单量', field: 'orders', width: '140px', sortable: false,  default: true},
          {id: 'returns', header: '退货量', field: 'returns', width: '140px',sortable: false, default: true},
          {id: 'returnsRate', header: '退货率(%)', field: 'slot:returnsRate', width: '140px', sortable: false,  default: true},
          {id: 'orderProductSales', header: '销售额', field: 'orderProductSales',prefix: this.params.row.currencySymbol, width: '140px', sortable: false, align: 'right', default: true},
          {id: 'orderProductSalesB2b', header: '销售额-B2B', field: 'orderProductSalesB2b',prefix: this.params.row.currencySymbol, width: '140px', sortable: false, align: 'right'},
          {id: 'discountCost', header: '促销折扣', field: 'discountCost',prefix: this.params.row.currencySymbol, width: '140px', sortable: false, align: 'right'},
          {id: 'realOrderProductSales', header: '实际销售额', field: 'realOrderProductSales',prefix: this.params.row.currencySymbol, width: '140px', sortable: false, align: 'right'},
          {id: 'avgOrderItemsSales', header: '平均销售价格', field: 'avgOrderItemsSales',prefix: this.params.row.currencySymbol, width: '140px', sortable: false, align: 'right'},
          {id: 'returnProductSales', header: '退款销售额', field: 'returnProductSales',prefix: this.params.row.currencySymbol, width: '140px', sortable: false, align: 'right'},
          {id: 'sessionsMobile', header: 'Sessions -移动端', field: 'sessionsMobile', width: '150px', sortable: false},
          {id: 'sessionsBrowser', header: 'Sessions -PC端', field: 'sessionsBrowser', width: '140px', sortable: false, default: true},
          {id: 'sessions', header: 'Sessions - 总计', field: 'sessions', width: '140px', sortable: false, default: true},
          {id: 'unitSessionPercentage', header: 'CVR(%)', field: 'slot:unitSessionPercentage', width: '140px', sortable: false,  default: true},
          {id: 'pageViewsMobile', header: 'PV -移动端', field: 'pageViewsMobile', width: '140px', sortable: false,  default: true},
          {id: 'pageViewsBrowser', header: 'PV -PC端', field: 'pageViewsBrowser', width: '140px', sortable: false,  default: true},
          {id: 'pageViews', header: 'PV - 总计', field: 'pageViews', width: '140px', sortable: false,  default: true},
          {id: 'buyBoxPercentage', header: 'BuyBox(%)', field: 'slot:buyBoxPercentage', width: '140px', sortable: false,  default: true},
          {id: 'adsImpressions', header: '广告曝光量', field: 'adsImpressions', width: '140px', sortable: false,  default: true},
          {id: 'adsClicks', header: '广告点击量', field: 'adsClicks', width: '140px', sortable: false, default: true},
          {id: 'ctr', header: 'CTR(%)', field: 'slot:ctr',  width: '140px',sortable: false,  default: true},
          {id: 'adsSpend', header: '广告花费', field: 'adsSpend',prefix: this.params.row.currencySymbol, width: '140px', sortable: false, align: 'right', default: true},
          {id: 'cpc', header: 'CPC', field: 'cpc',prefix: this.params.row.currencySymbol, width: '140px', sortable: false, align: 'right', default: true},
          {id: 'adsOrders', header: '广告订单量', field: 'adsOrders', width: '140px', sortable: false,  default: true},
          {id: 'adsOrdersRate', header: '广告订单占比(%)', field: 'slot:adsOrdersRate', width: '140px', sortable: false,  default: true},
          {id: 'cr', header: '广告CVR(%)', field: 'slot:cr', width: '140px', sortable: false,  default: true},
          {id: 'adsSales', header: '广告销售额', field: 'adsSales',prefix: this.params.row.currencySymbol, width: '140px', sortable: false, align: 'right'},
          {id: 'acoS', header: 'ACOS(%)', field: 'slot:acoS', width: '140px', sortable: false },
          {id: 'acoAS', header: 'ACOAS(%)', field: 'slot:acoAS', width: '140px', sortable: false},
          {id: 'asoAS', header: 'ASOAS(%)', field: 'slot:asoAS', width: '140px', sortable: false},
          {id: 'roAS', header: 'ROAS', field: 'roAS', width: '140px', sortable: false},
          {id: 'salesGrossProfit', header: '销售毛利', field: 'salesGrossProfit',prefix: this.params.row.currencySymbol, width: '140px', sortable: false, align: 'right'},
          {id: 'grossProfitRate', header: '销售毛利率(%)', field: 'slot:grossProfitRate', width: '140px', sortable: false},
          {id: 'salesNetProfit', header: '销售净毛利', field: 'salesNetProfit',prefix: this.params.row.currencySymbol, width: '140px', sortable: false, align: 'right'},
          {id: 'salesNetProfitRate', header: '销售净毛利率(%)', field: 'slot:salesNetProfitRate', width: '150px', sortable: false},
        ],
        chartTableColumns: [
          {id: 'name', header: '', field: 'name'},
          {id: 'total', header: 'slot:totalTime', width: '230px', field: 'total', align: 'right', default: true},
          {id: 'sevenAvg', header: '7天日均', field: 'sevenAvg', align: 'right', default: true, help: '最近7天'},
          {id: 'thirtyAvg', header: '30天日均', field: 'thirtyAvg', align: 'right', default: true, help: '最近30天'},
          {id: 'monthAvg', header: '本月日均', field: 'monthAvg', align: 'right', default: true, help: '当前月份'},
          {id: 'totalAvg', header: '所选日期日均', field: 'totalAvg', 
             align: 'right', default: true},
        ],
        chartTableData: [],
        leftSelectOption:[
          {id: 'unitsOrdered', text: '销量'},
          {id: 'unitsOrderedB2b', text: '销量-B2B'},
          {id: 'multiChannelOrders', text: '多渠道销量'},
          {id: 'orders', text: '订单量'},
          {id: 'returns', text: '退货量'},
          {id: 'returnsRate', text: '退货率(%)'},
          {id: 'refunds', text: '退款量'},
          {id: 'refundsRate', text: '退款率(%)'},
          {id: 'orderProductSales', text: '销售额'},
          {id: 'orderProductSalesB2b', text: '销售额-B2B'},
          {id: 'discountCost', text: '促销折扣'},
          {id: 'realOrderProductSales', text: '实际销售额'},
          {id: 'avgOrderItemsSales', text: '平均销售价格'},
          {id: 'returnProductSales', text: '退款销售额'},
          {id: 'sessionsMobile', text: 'Sessions -移动端'},
          {id: 'sessionsBrowser', text: 'Sessions -PC端'},
          {id: 'sessions', text: 'Sessions - 总计'},
          {id: 'unitSessionPercentage', text: 'CVR(%)'},
          {id: 'pageViewsMobile', text: 'PV -移动端'},
          {id: 'pageViewsBrowser', text: 'PV -PC端'},
          {id: 'pageViews', text: 'PV - 总计'},
          {id: 'buyBoxPercentage', text: 'BuyBox(%)'},
          {id: 'adsImpressions', text: '广告曝光量'},
          {id: 'adsClicks', text: '广告点击量'},
          {id: 'ctr', text: 'CTR(%)'},
          {id: 'adsSpend', text: '广告花费'},
          {id: 'cpc', text: 'CPC'},
          {id: 'adsOrders', text: '广告订单量'},
          {id: 'adsOrdersRate', text: '广告订单占比(%)'},
          {id: 'cr', text: '广告CVR(%)'},
          {id: 'adsSales', text: '广告销售额'},
          {id: 'acoS', text: 'ACOS(%)'},
          {id: 'acoAS', text: 'ACOAS(%)'},
          {id: 'asoAS', text: 'ASOAS(%)'},
          {id: 'roAS', text: 'ROAS'},
          {id: 'salesGrossProfit', text: '销售毛利'},
          {id: 'grossProfitRate', text: '销售毛利率(%)'},
          {id: 'salesNetProfit', text: '销售净毛利'},
          {id: 'salesNetProfitRate', text: '销售净毛利率(%)'},

        ],
        rightSelectOption:[],
        leftSelected:[],
        rightSelected:[],
        oldLeftSelected:[],
        oldRightSelected:[],
        filter: {
          dateType: 'day',
          date: null,
        },
        time:'所选时间段',
        alreadyShowTable:false,
        viewType: 'chart',
        alreayShowTable:false,
        chart: null,
        chartOption: null,
        option:{
          color:["rgb(0, 153, 255)", "rgb(81, 211, 81)", '#F3667C','#46A1FF','#89D1EA','#4DCBCB','#85DFBE','#5ACB74','#ACDF84','#FAD54C','#FAF357','#EAA775'],
          legend: {
            left:'auto',
            itemGap: 10,
            icon: "rect",
            itemWidth: 15,
            itemHeight: 3,
            textStyle: {
              color: '#888',
              padding: [2, 0, 0, 0],
            }
          },
          tooltip: {
            trigger: 'axis'
          },
          grid: {
            left: '18',
            right: '18',
            containLabel: true
          },
          dataZoom: [
            {
              start: 0,
              end: 100,
              left:100,
              right:100
            }
          ],
          xAxis: {
            data: [],
            axisLine: {
            show: false,
            lineStyle: {
              color: "#e5e9f2"
            }
            },
            axisLabel: {

              color: "#32393d"
            },
          },
          yAxis: [
            {
              type: 'value',
              position: 'left',
              splitLine: {
                lineStyle: {
                  color: "#e5e9f2"
                }
              },
              axisLabel: {
                  color: "#32393d"
               },
              axisLine: {
                show: false,
                lineStyle: {
                  color: "#FFF"
                }
              }
            },
            {
              type: 'value',
              position: 'right',
              axisLabel: {
               formatter: '{value} %',
                  color: "#32393d"
               },
              axisLine: {
                show: false,
                lineStyle: {
                  color: "#FFF"
                }
              }
            }
          ],
          series: [
          ]
        },
        //把每个字段怼成一个总的字典，然后选择的时候，以id为key，把【】提取出来，拼到option.series[i].data 里面去
        totalDict:{
          // "1":{"data":[1820, 1932, 1901, 1934, 1290, 1330, 1320],name:'1',isPercent:false},
          // "2":{"data":[20, 32, 1, 24, 10, 30, 90],name:'2',isPercent:true},
        },
        percentIdArray:['returnsRate','refundsRate','cr','ctr','buyBoxPercentage','unitSessionPercentage','adsOrdersRate','acoS','acoAS','asoAS','grossProfitRate','salesNetProfitRate'],
        defaultSelectDict:{
          'unitsOrdered':[['unitsOrdered','orders'],['orderProductSales']],
          'adsImpressions':[['adsOrders','adsImpressions','adsClicks'],['ctr','cr','adsOrdersRate']],
          'cpc':[['cpc','adsSpend','adsSales'],['acoS','roAS','asoAS']],

        }
      }
    },
    created(){
      this.rightSelectOption = this._.cloneDeep(this.leftSelectOption);
      this.leftSelected = [this.params.field]
      let defaultSelectArray = this.defaultSelectDict[this.params.field]
      if(defaultSelectArray) {
        this.leftSelected = defaultSelectArray[0]
        this.rightSelected = defaultSelectArray[1]
      }
      this.filter.date = this.params.date
      this.$gjQuery()
      console.log('传过来的参数是',this.params)
    },
    methods: {
      configChartTableData(dict){
        let array = []
        this.leftSelectOption.forEach((selectItem)=> {
          let tempDict = dict[selectItem.id]
          if (tempDict) {
            tempDict.name = selectItem.text
            array.push(tempDict)
          }
        })
        this.chartTableData = array
      },
      configTotalDict(){
        

        let resultDict = {}
        var timeArray = []//x轴需要的时间数组
        this.leftSelectOption.forEach((selectItem)=> {
          let dict = {
            id:selectItem.id,
            name:selectItem.text,
            isPercent:this.percentIdArray.includes(selectItem.id)? true: false
          }
          var array = []
          timeArray = []
          this.tableData.forEach((listItem)=> {
            let item = listItem[selectItem.id]
            if (item){
              array.push(item)
            }else {
              
              array.push(0)
            }
            timeArray.push(listItem.dateRange)
          })
          
       
          dict.data = array
          resultDict[selectItem.id] = dict
        })
        this.option.xAxis.data = timeArray
        this.totalDict = resultDict
        
      },
      close() {
        this.$gjModal.$gjDestroy();
      },

      selectChange(){
         if (this.leftSelected.length + this.rightSelected.length > 10) {
          this.leftSelected = this._.cloneDeep(this.oldLeftSelected)
          this.rightSelected = this._.cloneDeep(this.oldRightSelected)
          this.$gjMessage.warning('最多不能超过10个')
          this.$refs.leftSelect.$forceUpdate();
          this.$refs.rightSelect.$forceUpdate();
          return
        }

        var optionLeftArray = []
        var optionRightArray = []
        var percentArray = []
        //规则1：左右2个选择器，只要选择了带%的，统统放右边，剩余的放左边. 
        //把带百分号的存percentArray . 如果 percentArray.length > 0 . 右边的数组倒入左边的数组，然后percentArray倒入右边。 这样就只要遍历一次就能适配规则1.
        this.leftSelected.forEach((item)=> {
          let dict = this.totalDict[item]
          if(dict.isPercent == true ) {
              percentArray.push({
                ...dict,
                yAxisIndex:1
              })
          }else {
            optionLeftArray.push({
              ...dict,
              yAxisIndex:0
            })
          }
          
        })

        this.rightSelected.forEach((item)=> {
          let dict = this.totalDict[item]
          if(dict.isPercent == true ) {
              percentArray.push({
                ...dict,
                yAxisIndex:1
              })
          }else {
            optionRightArray.push({
              ...this.totalDict[item],
              yAxisIndex:1
            })
          }
        })
       
        if(percentArray.length > 0) {
          optionRightArray.forEach((item)=> {
            item.yAxisIndex = 0
            optionLeftArray.push(item)
          })
          optionRightArray = []
          optionRightArray = percentArray
        }
        this.option.yAxis[1].axisLabel.formatter = percentArray.length > 0 ? '{value} %' : '{value}'
        //规则2：左边选了啥，右边就禁用啥，右边选了啥，左边也禁用啥
        this.leftSelectOption.forEach((item)=> {
          if(this.rightSelected.indexOf(item.id) > -1) {
            item.disabled = true
          }else{
            item.disabled = false
          }
        })
        this.rightSelectOption.forEach((item)=> {
          if(this.leftSelected.indexOf(item.id) > -1) {
            item.disabled = true
          }else{
            item.disabled = false
          }
        })
    

        //修改chart option
        this.option.series = []
        optionLeftArray.forEach((item)=> {
          this.option.series.push({
            ...item,
            type:'line'

          })
        })
        optionRightArray.forEach((item)=> {
          this.option.series.push({
             ...item,
            type:'line'
          })
        })
        this.oldLeftSelected = this._.cloneDeep(this.leftSelected)
        this.oldRightSelected = this._.cloneDeep(this.rightSelected)
        this.setOption()
        this.$nextTick(() => {

           this.$refs.leftSelect.$forceUpdate();
           this.$refs.rightSelect.$forceUpdate();

        })
      },
      leftSelectChange() {
        this.selectChange()
      },
      rightSelectChange() {
        this.selectChange()
      },
      changViewType2(viewType) {
        this.viewType = viewType;
        if (viewType === 'chart') {
          this.renderChart();
        }else {
          if (this.alreadyShowTable == false) {
              this.alreadyShowTable = true
          }
        }
        
      },
      modalOpen() {
        this.$nextTick(() => this.renderChart());
      },
      renderChart() {
        const chartRef = this.$refs.enlargeChart;
        if(chartRef){
          this.enlargeChart = this.$echarts.init(chartRef);
          this.enlargeChart && this.setOption();
        }
      },
      setOption(){

        this.enlargeChart.setOption(this.option, true);
      },
      //静态翻页时，接收当前页的数据
      getStaticData(val){
        // 若当前分页未请求过状态,则请求状态
        
        let beginIndex = (this.pagination.currentPage - 1) * this.pagination.pageSize
        let endIndex = beginIndex + this.pagination.pageSize
        this.currentTableData = this.tableData.slice(beginIndex,endIndex)
      },

      $gjReset() {
        this.filter = {
          dateType: 'day',
          date: this.params.date,
        }
      },
      $gjQuery() {
        this.loading = true;
        this.pagination.currentPage = 1
        let dict = {
          dateQueryType:this.filter.dateType,
          startStatisticsDate: convertToDate(this.filter.date[0]),
          endStatisticsDate: convertToDate(this.filter.date[1]),

          groupType:this.params.groupType,
        }
        // 区分父子树结构
        if(this.params.row.marketIds.indexOf(',') >= 0) {
          dict.marketIdStr = this.params.row.marketIds
        } else {
          dict.marketId = this.params.row.marketId
        }
        if (dict.groupType == 'msku') {
          dict.msku = this.params.row.msku
        }else if (dict.groupType == 'asin') {
          dict.asin = this.params.row.asin
        }else if (dict.groupType == 'variationAsin') {
          // 区分点击是父asin数据还是子asin数据
          if(this.params.row.parent) {
            dict.variationAsin = this.params.row.variationAsin
          }else {
            dict.groupType = 'asin';
            dict.asin = this.params.row.asin;
          }
        }
        this.time = dict.startStatisticsDate + '~' + dict.endStatisticsDate
        this.globalParams = dict


        getListingTrendAnalyze(dict)
          .then((res) => {
            this.tableData = res
            this.configTotalDict()
            this.selectChange()
            this.pagination.total = this.tableData.length;

            this.getStaticData()

          })
          .catch(() => {

          })
          .complete(() => {
            this.loading = false
            this.selectChange()
          });

        getListingTrendTotal(dict).then((res) => {
            this.configChartTableData(res)
          })
          .catch(() => {

          })
          .complete(() => {

          });
      },
    }
  }
</script>

<style scoped>
  .gj-content {
    color: #303133;
    font-weight: 500;
  }
  .rate {
    display: inline-block;
  }
  .rate-score {
    margin: 0 5px;
  }
  .header /deep/ .el-divider {
    background-color: #303133;
  }
  .analysis-content /deep/ .el-divider {
    margin: 6px 0 10px 0;
  }
  .product-name {
    color: #303133;
    font-size: 15px;
    font-weight: bold;
    display: inline-block;
    white-space: nowrap;
  }
  .gj-mb10 {
    margin-bottom: 6px;
  }
  /deep/ .gj-empty {
  width: 100px;
  padding: 10px;
}
  .analysis-content {
    display: flex;
    flex-direction: column;
    height: 100%;
  }
  .analysis-legend {
    line-height: 30px;
  }
  .analysis-legend--icon {
    height: 3px;
    width: 15px;
  }
  .analysis-legend--label {
    margin-left: 8px;
    color: rgba(0,0,0,0.65);
    font-size: 12px;
  }
  .content-options {
    margin: 10px 0;
  }
  .option-container {
    position: relative;
  }
  .option-divider {
    margin-right: 20px;
    position: absolute;
    height: 90px;
    width: 1px;
    border-left: 1px solid #e6e6e6;
    top: 0;
    right: 0;
  }
</style>
